/* Maps BE enum values to string values used in CSS classes or icon names.*/

import { IconName } from 'components/icon/Icon';

import {
  CampaignBlock_EditorTheme,
  ContentAreaItem_Size,
  DateCardMedia_Items_Icon,
  DateCardStatus_Theme,
  DocumentIcon_IconTheme,
  EducationBlock_EditorTheme,
  EventImage_Background,
  EventPageLink_Icon,
  FrontpageHeader_EditorTheme,
  IconWarning_Theme,
  ImageWithCaption_EditorTheme,
  LinkWithText_Theme,
  ListItemImage_Size,
  PortfolioTile_Theme,
  RelatedContent_Border,
  SatelliteHeader_TextColor,
  SearchResultGroup_IconName,
  ShareOptions_Items_Icon,
  SocialMediaLink_Provider,
  Status_Theme,
  FetchPrioritySelector
} from 'source/NFR.types';

// --- CSS CLASSES ---
export const CampaignBlock_EditorThemeMap: Record<number, string> = {
  [CampaignBlock_EditorTheme.None]: '',
  [CampaignBlock_EditorTheme.Dark]: 'campaign-block--theme-dark',
  [CampaignBlock_EditorTheme.Np]: 'campaign-block--theme-np'
};

export const ContentAreaItem_SizeMap: Record<number, string> = {
  [ContentAreaItem_Size.None]: '',
  [ContentAreaItem_Size.FullScreen]: 'content-area-item--size-full-screen',
  [ContentAreaItem_Size.Half]: 'content-area-item--size-half',
  [ContentAreaItem_Size.Third]: 'content-area-item--size-third',
  [ContentAreaItem_Size.Quarter]: 'content-area-item--size-quarter',
  [ContentAreaItem_Size.TwoThirds]: 'content-area-item--size-two-thirds'
};

export const DateCardStatus_ThemeMap: Record<number, string> = {
  [DateCardStatus_Theme.None]: '',
  [DateCardStatus_Theme.IsActive]: 'date-card-status--is-active',
  [DateCardStatus_Theme.IsCompleted]: 'date-card-status--is-completed',
  [DateCardStatus_Theme.ResultIsPublished]: 'date-card-status--result-is-published',
  [DateCardStatus_Theme.IsCanceled]: 'date-card-status--is-canceled',
  [DateCardStatus_Theme.IsPlanned]: 'date-card-status--is-planned'
};

export const EducationBlock_EditorThemeMap: Record<number, string> = {
  [EducationBlock_EditorTheme.None]: '',
  [EducationBlock_EditorTheme.Blue]: 'education-block--theme-blue',
  [EducationBlock_EditorTheme.Yellow]: 'education-block--theme-yellow'
};

export const FrontpageHeader_EditorThemeMap: Record<number, string> = {
  [FrontpageHeader_EditorTheme.None]: '',
  [FrontpageHeader_EditorTheme.Yellow]: 'frontpage-header--theme-yellow',
  [FrontpageHeader_EditorTheme.Red]: 'frontpage-header--theme-red',
  [FrontpageHeader_EditorTheme.Esaki]: 'frontpage-header--theme-esaki',
  [FrontpageHeader_EditorTheme.Marconi]: 'frontpage-header--theme-marconi',
  [FrontpageHeader_EditorTheme.Alfven]: 'frontpage-header--theme-alfven'
};

export const IconWarning_ThemeMap: Record<number, string> = {
  [IconWarning_Theme.None]: '',
  [IconWarning_Theme.Red]: 'icon-warning--theme-red',
  [IconWarning_Theme.Blue]: 'icon-warning--theme-blue',
  [IconWarning_Theme.Gray]: 'icon-warning--theme-gray'
};

export const ImageWithCaption_EditorThemeMap: Record<number, string> = {
  [ImageWithCaption_EditorTheme.None]: '',
  [ImageWithCaption_EditorTheme.HalfWidth]: 'image-with-caption--theme-half-width'
};

export const LinkWithText_ThemeMap: Record<number, string> = {
  [LinkWithText_Theme.None]: '',
  [LinkWithText_Theme.Gray]: 'link-with-text--theme-gray',
  [LinkWithText_Theme.Prominent]: 'link-with-text--theme-prominent'
};

export const ListItemImage_SizeMap: Record<number, string> = {
  [ListItemImage_Size.None]: '',
  [ListItemImage_Size.SmallImage]: 'list-item-image--size-small'
};

export const PortfolioTile_ThemeMap: Record<number, IconName | ''> = {
  [PortfolioTile_Theme.None]: '',
  [PortfolioTile_Theme.Education]: 'category-apple',
  [PortfolioTile_Theme.Technologies]: 'category-building',
  [PortfolioTile_Theme.Democracy]: 'category-democracy',
  [PortfolioTile_Theme.Industry]: 'category-factory',
  [PortfolioTile_Theme.Food]: 'category-grain',
  [PortfolioTile_Theme.Welfare]: 'category-handshake',
  [PortfolioTile_Theme.Health]: 'category-heart',
  [PortfolioTile_Theme.Climate]: 'category-iceberg',
  [PortfolioTile_Theme.Petroleum]: 'category-oil-drum',
  [PortfolioTile_Theme.Humanities]: 'category-people',
  [PortfolioTile_Theme.Science]: 'category-science',
  [PortfolioTile_Theme.Nature]: 'category-tree',
  [PortfolioTile_Theme.Energy]: 'category-windmill',
  [PortfolioTile_Theme.Global]: 'category-globe',
  [PortfolioTile_Theme.Ocean]: 'category-ocean',
  [PortfolioTile_Theme.Sami]: 'category-sami'
};

export const RelatedContent_BorderMap: Record<number, string> = {
  [RelatedContent_Border.None]: '',
  [RelatedContent_Border.Top]: 'related-content__item--border-top',
  [RelatedContent_Border.Bottom]: 'related-content__item--border-bottom'
};

export const SatelliteHeader_TextColorMap: Record<number, string> = {
  [SatelliteHeader_TextColor.None]: '',
  [SatelliteHeader_TextColor.Light]: 'satellite-header__lead--light-text'
};

export const Status_ThemeMap: Record<number, string> = {
  [Status_Theme.None]: '',
  [Status_Theme.IsActive]: 'status--is-active',
  [Status_Theme.IsCompleted]: 'status--is-completed',
  [Status_Theme.ResultIsPublished]: 'status--result-is-published',
  [Status_Theme.IsCanceled]: 'status--is-canceled',
  [Status_Theme.IsPlanned]: 'status--is-planned'
};

export const FetchPrioritySelectorMap: Record<number, 'auto' | 'high'> = {
  [FetchPrioritySelector.Default]: 'auto',
  [FetchPrioritySelector.High]: 'high'
};

// --- ICON AND ASSETS NAMES ---
// --- ICON AND ASSETS NAMES ---
// --- ICON AND ASSETS NAMES ---

export const DateCardMedia_Items_IconMap: Record<number, IconName> = {
  [DateCardMedia_Items_Icon.Slideshow]: 'slideshow',
  [DateCardMedia_Items_Icon.Video]: 'video',
  [DateCardMedia_Items_Icon.Camera]: 'camera'
};
export const DocumentIcon_IconThemeMap: Record<number, string> = {
  [DocumentIcon_IconTheme.None]: '',
  [DocumentIcon_IconTheme.Word]: 'word',
  [DocumentIcon_IconTheme.Pdf]: 'pdf',
  [DocumentIcon_IconTheme.Ppt]: 'ppt',
  [DocumentIcon_IconTheme.Excel]: 'excel',
  [DocumentIcon_IconTheme.Fallback]: 'fallback',
  [DocumentIcon_IconTheme.Csv]: 'csv',
  [DocumentIcon_IconTheme.Image]: 'image'
};

export const EventImage_BackgroundMap: Record<number, string> = {
  [EventImage_Background.None]: '',
  [EventImage_Background.Background1]: 'background1',
  [EventImage_Background.Background2]: 'background2',
  [EventImage_Background.Background3]: 'background3',
  [EventImage_Background.Background4]: 'background4'
};

export const EventPageLink_IconMap: Record<number, IconName> = {
  [EventPageLink_Icon.Video]: 'video',
  [EventPageLink_Icon.Calendar]: 'calendar'
};

export const SearchResultGroup_IconNameMap: Record<number, IconName | ''> = {
  [SearchResultGroup_IconName.None]: '',
  [SearchResultGroup_IconName.Mail]: 'mail-thick',
  [SearchResultGroup_IconName.Document]: 'document'
};

export const ShareOptions_Items_IconMap: Record<number, IconName | ''> = {
  [ShareOptions_Items_Icon.None]: '',
  [ShareOptions_Items_Icon.Facebook]: 'facebook-logo',
  [ShareOptions_Items_Icon.Linkedin]: 'linkedin-logo',
  [ShareOptions_Items_Icon.Mail]: 'envelope'
};

export const SocialMediaLink_ProviderMap: Record<number, IconName | ''> = {
  [SocialMediaLink_Provider.None]: '',
  [SocialMediaLink_Provider.Facebook]: 'some-facebook',
  [SocialMediaLink_Provider.Linkedin]: 'some-linkedin',
  [SocialMediaLink_Provider.Rss]: 'some-rss',
  [SocialMediaLink_Provider.Instagram]: 'some-instagram'
};

// --- HELPER FUNCTIONS ---
// --- HELPER FUNCTIONS ---
// --- HELPER FUNCTIONS ---

// Utility function to get the value from an enum map (works with both string and IconName maps)
// Example usage:
// const editorTheme = 2 // Value comes from BE.
// const themeClass = getEnumStringValue(CampaignBlock_EditorThemeMap, editorTheme); // Returns: '-theme-np'
// const iconName = getEnumStringValue(EventPageLink_IconMap, icon); // Returns: IconName
export function getEnumStringValue<T extends string>(map: Record<number, T>, value?: number): T | '' | undefined {
  return map[value ?? 0] ?? ('' as T | '');
}

// Utility function to get a value from an object using an enum map
// This combines enum-to-string mapping with object lookup in one step
// Example usage:
// const backgrounds = { background1: img1, background2: img2 };
// const background = 1; // Value from BE (EventImage_Background.Background1)
// const bgUrl = getObjectByEnumMap(EventImage_BackgroundMap, backgrounds, background);
// Result: bgUrl = img1
export function getObjectByEnumMap<T, K extends string>(
  map: Record<number, K>,
  obj: Record<string, T>,
  enumValue?: number
): T | undefined {
  const key = getEnumStringValue(map, enumValue);
  if (!key) return undefined;
  return obj[key];
}

// ===========================
// THEME KEY MAPS
// These maps convert backend enum values to theme keys used by defineTheme()
// Use these when you need to pass backend enums to components using defineTheme
// ===========================

// Maps IconWarning_Theme enum to theme keys (not CSS classes)
// Use with: defineTheme({ red: '...', blue: '...', gray: '...' })
export const IconWarning_ThemeKeysMap: Record<number, string> = {
  [IconWarning_Theme.None]: '',
  [IconWarning_Theme.Red]: 'red',
  [IconWarning_Theme.Blue]: 'blue',
  [IconWarning_Theme.Gray]: 'gray'
};

// Helper to convert backend enum to defineTheme key
// Example:
// const theme = 1; // IconWarning_Theme.Red from backend
// const themeKey = getThemeKey(IconWarning_ThemeKeysMap, theme); // 'red'
// <Component theme={themeKey} />
export function getThemeKey(keyMap: Record<number, string>, enumValue?: number): string | undefined {
  const key = keyMap[enumValue ?? 0];
  return key || undefined;
}
